module.exports = [{
      plugin: require('/var/www/ipos-stage/ipos_pl/front/node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
      options: {"plugins":[],"layout":"/var/www/ipos-stage/ipos_pl/front/src/layouts/index.tsx"},
    },{
      plugin: require('/var/www/ipos-stage/ipos_pl/front/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"typekit":{"id":"hjd4zgx"}},
    },{
      plugin: require('/var/www/ipos-stage/ipos_pl/front/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
